import React from 'react';
import request from 'superagent';
import { Alert, Spin, message } from 'antd';
//import URI from 'urljs';

// ----------------------------------------------------------------------------
// Dimio
// ----------------------------------------------------------------------------
export const LoadingSpinner = (meta) => (
  <div className='dimio-loader'>
    {meta.processing &&
    <Spin />
    }
  </div>
);

export const ErrorMessage = (meta) => (
  <div className='dimio-error'>
    {meta.error &&
    <Alert message={meta.error} type="error" />
    }
  </div>
);

export const DimioNotice = (meta) => (
  <div>
    {meta.processing &&
    <div className="loading-spinner d-flex justify-content-center align-items-center" >
      <Spin size="large" tip="processing"/>
    </div>
    }

    {/* meta.success &&
    <Alert message={meta.success} type="success" />
    */}

    {meta.error &&
      <div style={{position:'fixed', zIndex:10, top:10, left:20, width:'90%'}}>
        <Alert message={meta.error} type="error" style={{padding:'1rem 1.5rem'}}/>
      </div>
    }
  </div>
);

/**
 *
 */
class Dimio{
  /*
  static uri(opt){
    const uri = URI();
    if (opt.home) {
      let url = uri.segment([uri.segment(0), uri.segment(1), uri.segment(2)]);
      return url.toString();
    } else {
      uri.segment(opt.pos, opt.value);
      //const url = seg.join('/');
      let url = uri.toString();
      console.info(url);
      return url;
    }
  }
  */

  getJPY(){

  }

  apiSuccess(response, options){
    if(response.body.success === true){
      if(options.onSuccess){
        options.onSuccess(response.body);
      }
    }else{
      message.error(response.body.error);
      if(options.onError){
        options.onError(response.body.error);
      }
//      debugger;
    }
    return response;
  };

  apiError(error, options){
    if(error.status === 500){
//      debugger;
      message.error('問題が発生しました');
      // send auto message
    }else {
      if (options.onError) {
        options.onError((error.response)?error.response.body:error);
      }else{

//        message((error.response)?error.response.body:error);
      }
    }
    console.error((error.response)?error.response.body:error);
  };

  load(url, options){
    console.info('[LOAD] '+url, options.query);
    request
      .get(url)
      .query(options.query)
      .type('json')
      //        .then(this.apiResponse)
      .then (res => this.apiSuccess(res, options))
      .catch(err => this.apiError(err, options));
  }

  save(url, options){
    console.info('[SAVE] ' + url, options.data);
    request
      .post(url)
      .send(options.data)
      .type('form')
      //        .then(this.apiResponse)
      .then (res => this.apiSuccess(res, options))
      .catch(err => this.apiError(err, options));
  }

  load2(url, options){
    console.info('[LOAD 2] ' + url, options.data);
    return request
      .get(url)
      .query(options.query)
      .type('json')
      //        .then(this.apiResponse)
      .then (res => {
        return res.body;
      })
      .catch(err => this.apiError(err, options));

  }

}

export default Dimio;



// WEBPACK FOOTER //
// ./src/components/Dimio.js